import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconRendition$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconRendition extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'b15354e949422d3839cf0fdf2e44ece601d18d62', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '69493b9bbe51f427c80d28cf23e1ff59839cb6ca', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '892d035fbf344f7450ef111d0422198fe50db088', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.05 7.86a.5.5 0 0 0 .07-.59L17 5.23a.5.5 0 0 0-.6-.23l-2.48.58a6.6 6.6 0 0 0-1.36-.78l-.74-2.44a.48.48 0 0 0-.48-.36H9a.49.49 0 0 0-.48.36L7.79 4.8a6.4 6.4 0 0 0-1.37.78L3.94 5a.49.49 0 0 0-.54.23l-1.18 2a.5.5 0 0 0 .07.59L4 9.71a6.3 6.3 0 0 0 0 1.58l-1.71 1.85a.5.5 0 0 0-.07.59l1.18 2a.49.49 0 0 0 .54.23l1.67-.39a.51.51 0 0 0 .39-.45v-3.35a4.15 4.15 0 0 1 .33-3.68 4.38 4.38 0 0 1 8.18 1.47.51.51 0 0 0 .49.44h1.07a.48.48 0 0 0 .39-.19z", fill: "currentColor" }), h("path", { key: 'dff30798feb7d337e025213af79d538bd7ae477d', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M19.5 12h-11a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5", fill: "#DB0A40" }), h("path", { key: '740cca1408f662009ec8545c38b8e97dae9cb1f2', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9.501 18.212A4.6 4.6 0 0 1 14 13.5a4.6 4.6 0 0 1 4.499 4.712z", fill: "#fff" }), h("path", { key: 'e5e91288b1aba46ce5e4558a06e2a37b976554a7', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m14.596 17.279.281-2.024a.157.157 0 0 0-.27-.113l-1.327 1.552a.18.18 0 0 0 .068.292l.978.45a.19.19 0 0 0 .27-.157", fill: "#DB0A40" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-rendition", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-rendition"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-rendition":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconRendition$1);
            }
            break;
    } });
}

const CosmosIconRendition = CosmosIconRendition$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconRendition, defineCustomElement };
